import { isEmpty } from 'lodash';
import { useEffect } from 'react';

import { MedicalLeavePayer } from '@dreryk/egabinet-ezla-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { MedicalLeaveCommonFormController } from '../../common.types';
import { mapMedicalLeavePayersToMedicalLeavePuePayers } from '../../common.utils';
import { MedicalLeaveFormSection } from '../MedicalLeaveFormSection';

import { PayerIdentificationNumberField } from './PayerIdentificationNumberField';
import { PayerIdentificationNumberTypeField } from './PayerIdentificationNumberTypeField';
import { PayerNameField } from './PayerNameField';

type MedicalLeaveFormForeignPayerSectionProps = {
   readonly controller: MedicalLeaveCommonFormController;
   readonly payersForeignRecentlyApproved: MedicalLeavePayer[];
   readonly title: TranslatableText;
};

export const MedicalLeaveFormForeignPayerSection = (props: MedicalLeaveFormForeignPayerSectionProps): JSX.Element => {
   useEffect(() => {
      const currentPayers = props.controller.getValue('payers');
      if (
         isEmpty(
            [...(currentPayers ?? [])].filter(
               (payer) => payer.name || payer.identificationNumber || payer.identificationNumberType
            )
         ) &&
         !isEmpty(props.payersForeignRecentlyApproved)
      ) {
         props.controller.reset(
            {
               ...props.controller.getValues(),
               payers: mapMedicalLeavePayersToMedicalLeavePuePayers(props.payersForeignRecentlyApproved),
            },
            {
               dirtyFields: true,
               errors: true,
               isDirty: true,
               isSubmitted: true,
               isValid: true,
               submitCount: true,
               touched: true,
            }
         );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      props.controller.register('payers');
   }, [props.controller]);

   return (
      <MedicalLeaveFormSection title={props.title}>
         <StyledFlex direction={'column'} gap={'18px'}>
            <PayerNameField register={props.controller.register} />
            <StyledFlex direction={'row'} gap={'18px'}>
               <PayerIdentificationNumberTypeField register={props.controller.register} />
               <PayerIdentificationNumberField register={props.controller.register} />
            </StyledFlex>
         </StyledFlex>
      </MedicalLeaveFormSection>
   );
};
